<template lang="pug">
    ApolloQuery(:query="require('../graphql/CareerPath.gql')",:variables="{ locale }")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.career_path)")
            .career-path(v-else)
                MetaTags(v-bind="data.career_path.meta_tags")
                LayoutBannerBreadCrumb(:locale='locale',  :cover="data.career_path.cover", :name="data.career_path.title")
                .container.container__padded.container-career-path
                    .row
                        .col-12
                            .leadin(v-html="data.career_path.mission_statement")
                            .image.d-none.d-md-block.d-lg-block
                                img(v-bind="data.career_path.career_prospect_image.default")
                            .image.d-block.d-md-none.d-lg-none
                                img(v-bind="data.career_path.career_prospect_image.mobile")
                WidgetHowToJoin(v-if="data.career_path.page_bottom", v-bind="data.career_path.page_bottom")
</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import WidgetHowToJoin from "../components/WidgetHowToJoin.vue";
    import Loading from "../components/Loading.vue";
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "CareerPath",
        props: {
            locale: String
        },
        components: {
            MetaTags,
            PageNotFound,
            LayoutBannerBreadCrumb,
            WidgetHowToJoin,
            Loading
        }
    };
</script>

<style lang="sass" scoped>
@import "../../node_modules/bootstrap/scss/functions"
@import "../assets/styles/CustomVariables"
@import "../assets/styles/wysiwyg"
@import "../assets/styles/common"
@import "../../node_modules/bootstrap/scss/variables"
@import "../../node_modules/bootstrap/scss/mixins"
@import "../../node_modules/bootstrap/scss/grid"
.container-career-path
    .leadin
        padding: 0

    @extend .container
    .image
        margin-top: 5rem
        text-align: center
        @include media-breakpoint-down(lg)
            margin-top: 2rem
</style>
